<script>
  export let last = false;
  export let first = false;
  export let tight = false;
  export let small = false;
  export let italic = false;
</script>

<p
  class="paragraph"
  class:small
  class:italic
  class:tight
  class:last
  class:first
>
  <slot></slot>
</p>

<style>
  .italic {
    font-style: italic;
  }
  .small {
    font-size: 12px;
  }
  .paragraph {
    line-height: 1.5;
    margin: 0;
    padding: 0;
  }
  :global(.paragraph + .paragraph) {
    margin-top: 1em;
  }
  :global(.paragraph:last-child) {
  }
  .tight {
    line-height: initial;
  }
  .last {
  }
  .first {
  }
</style>
